import { Link } from "@tanstack/react-router";
import { ChevronRight, Lock, UserCircle } from "lucide-react";

import { Card, CardContent } from "@workspace/web-ui/components/card";

interface SettingsItem {
  to: string;
  icon: React.ReactElement;
  title: string;
  description: string;
}

const SettingsCard = ({ to, icon, title, description }: SettingsItem) => (
  <Link
    to={to}
    className="group block"
    aria-label={`Navigate to ${title} settings`}
  >
    <Card className="transition-colors hover:border-neutral-200 hover:bg-neutral-50/50">
      <CardContent className="flex items-center justify-between p-6">
        <div className="flex items-center gap-4">
          <div
            className="rounded-lg bg-neutral-100 p-2.5 group-hover:bg-neutral-200"
            aria-hidden="true"
          >
            {icon}
          </div>
          <div>
            <h3 className="font-semibold">{title}</h3>
            <p className="text-sm text-muted-foreground">{description}</p>
          </div>
        </div>
        <ChevronRight
          className="h-5 w-5 text-muted-foreground transition-transform group-hover:translate-x-0.5"
          aria-hidden="true"
        />
      </CardContent>
    </Card>
  </Link>
);

const settingsItems: SettingsItem[] = [
  {
    to: "/dashboard/settings/user-profile",
    icon: <UserCircle className="h-6 w-6 text-neutral-600" />,
    title: "Profile Information",
    description: "Update your profile details and preferences",
  },
  {
    to: "/dashboard/settings/change-password",
    icon: <Lock className="h-6 w-6 text-neutral-600" />,
    title: "Password",
    description: "Change your password and security settings",
  },
];

const SettingsPage = () => {
  return (
    <div
      className="grid gap-4"
      role="navigation"
      aria-label="Settings navigation"
    >
      {settingsItems.map((item, index) => (
        <SettingsCard key={`settings-item-${index}`} {...item} />
      ))}
    </div>
  );
};

export default SettingsPage;
